<template>
  <div class="container workshops">
    <div class="row mb-45" >
      <div class="col-lg-8 col-12">
        <h1>Wellbeing Workshops</h1>
      </div>
    </div>

    <div class="col-12">
        <hr />
    </div>


    <div class="row">
      <div class="col-12 d-lg-none">
        <button class="modal-filters btn-secondary large-filters-btn" type="button" @click="showFilters()">
          <font-awesome-icon
            :icon="['fas', 'sliders-v']"
            class="icon alt"
          />
          <span>Filters</span>
        </button>
      </div>
      <div class="col-12 col-lg-8">
        <div class="dashboard-card workshops-list" >
          <b-tabs content-class="mt-3" fill>
            <b-tab title="Approved">
              <workshop-approved-list 
                :filters="filters"
                @canceled="reload"
                @withdrawn="reload"
                @refunded="reload"
                ref="approvedList"
              />
            </b-tab>
            <b-tab title="Requests">
              <workshop-requests-list 
                :filters = "filters"
                @approved="reload"
                @rejected="reload"
                ref="requestedList"
              />
            </b-tab>
            <b-tab title="Canceled">
              <workshop-canceled-list 
                :filters = "filters"
                ref="canceledList"
              />
            </b-tab>

          </b-tabs>
          
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-4">
        <div class="dashboard-card filter-sidebar">
          <workshops-list-filter 
            :value="filters" 
            @input="resetFilters" />
        </div>
      </div>
    </div>
    <b-modal
      ref="filtersModal"
      id="filters-modal"
    >
      
      <workshops-list-filter 
        v-model="modalFilters" />

      <template
        slot="modal-footer"
      >
        <button
          class="btn"
          type="button"
          @click="hideFilters()"
        >
          Cancel
        </button>
        <button
          class="btn btn--primary"
          type="button"
          @click="doModalFilters()"
        >
          Filter
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import WorkshopClient from '@/api/WorkshopClient';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import Loader from '@/components/Loader';
import WorkshopsListFilter from './components/WorkshopsListFilter.vue'
import WorkshopRequestsList from './components/WorkshopRequestsList.vue';
import WorkshopCanceledList from './components/WorkshopCanceledList.vue';
import AttendeesAdminViewModal from './components/AttendeesAdminViewModal.vue';
import WorkshopAdminViewModal from './components/WorkshopAdminViewModal.vue';
import WorkshopApprovedList from './components/WorkshopApprovedList.vue';
import moment from 'moment';

export default {
  name: 'WorkshopsList',
  components: {
    Loader,
    WorkshopsListFilter,
    ConfirmModal,
    WorkshopRequestsList,
    WorkshopCanceledList,
    AttendeesAdminViewModal,
    WorkshopAdminViewModal,
    WorkshopApprovedList
  },
  data() {
    return {
      workshopClient: new WorkshopClient(this.$http),

      filters: {
        specialty: '',
        start_time_after: moment().toISOString(),
        start_time_before: '',
        specialty_ids: [],
      },
      modalFilters: {
        specialty: '',
        start_time_after: '',
        start_time_before: '',
        specialty_ids: [],
      },
      
    };
  },
  methods: {
    showFilters() {
      this.modalFilters = { ...this.filters };
      this.$refs.filtersModal.show();
    },
    doModalFilters() {
      this.filters = { ...this.modalFilters };
      this.hideFilters();
      this.pageToken = null;
      
      return this.reload();
    },
    hideFilters() {
      this.$refs.filtersModal.hide();
    },
    resetFilters(filters) {
      this.filters=filters;
      this.pageToken = null;
      
      return this.reload();
    },
    specialtyChanged(newTags) {
      this.filters.specialty_ids = newTags;
      this.reload();
    },
    modalSpecialtyChanged(newTags) {
      this.modalFilters.specialty_ids = newTags;
      this.reload();
    },
    reload() {
      setTimeout(() => {
        this.$refs.approvedList.freshLoadWorkshops();
        this.$refs.requestedList.freshLoadWorkshops();
        this.$refs.canceledList.freshLoadWorkshops();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.workshops {
  .workshops-list {
    .upper {
      margin-bottom: 30px;
    }

    .nav-buttons {
      position: absolute;
      right: 42px;
      top: 28px;

      @media (max-width: $xs-max) {
        position: static;
        margin-top: 20px;
      }

      button {
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        width: 35px;

        @media (max-width: $md-max) {
          width: 50px;
        }
      }
    }
}
}
.create-button {
  display: inline-block;
  margin-top: 7px;
}

</style>
